import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import { can } from 'app/helpers/can';
import { isLoggedInAsAdmin } from 'app/helpers/isLoggedInAsAdmin';
import { Params } from 'app/types';
import AgencyProfileIcon from 'app/ui/icons/AgencyProfileIcon';
import BookingsIcon from 'app/ui/icons/BookingsIcon';
import DashboardIcon from 'app/ui/icons/DashboardIcon';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import MessagingIcon from 'app/ui/icons/MessagingIcon';
import PaymentsIcon from 'app/ui/icons/PaymentsIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import SettingsIcon from 'app/ui/icons/SettingsIcon';
import WindowBookmarkIcon from 'app/ui/icons/WindowBookmarkIcon';
import CertificatesMenuIcon from 'app/ui_v2/icons/CertificatesMenuIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';
import InvitationsMenuIcon from 'app/ui_v2/icons/InvitationsMenuIcon';

import { getAdminLink } from './agency';

const clientGuideUrl = assetUrl('../../../Tertius_User_Guide_For_Third-Party_Customers.pdf?updated=14082024');
const clientDcraGuideUrl = assetUrl('../../../DOB_Construction_Inspections_User_Guide_for_Customers.pdf');

export const getClientNavigation = (user: AppNS.User): AppNS.NavigationElement[] => [
  {
    id: 'dashboard',
    name: 'Dashboard',
    url: '/client/dashboard',
    path: '/client/dashboard',
    icon: <DashboardIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'bookings',
    name: 'My Projects',
    url: '/client/bookings',
    path: ['/client/bookings/:id', '/job-create', '/find-a-agency/:id'],
    icon: <BookingsIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/client/messaging/inbox',
    path: '/client/messaging/:id',
    icon: <MessagingIcon />,
    disabled: false, // !ifClientDuringOnboarding(user),
    show: true,
  },
  {
    id: 'payments',
    name: 'Payments',
    url: '/client/payments',
    path: '/client/payments/:id',
    icon: <PaymentsIcon />,
    disabled: !can(user, 'view_company_payments'),
    show: true,
    main: true,
  },
  {
    id: 'profile',
    name: 'MyProfile',
    url: '/client/profile',
    path: '/client/profile/:id',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: clientGuideUrl,
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'wrapper-test',
    name: `Wrapper Test`,
    url: '/client/check-wrapper',
    path: '/client/check-wrapper',
    icon: <DashboardIcon />,
    disabled: false,
    show: user.email.indexOf('near-me.com') > -1 || user.email.indexOf('streflik') > -1,
    isExternal: false,
  },
  {
    id: 'company',
    name: 'Company and Users',
    url: '/client/company/main',
    path: '/client/company/main',
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/client/settings',
    path: '/client/settings/:id',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getDcraClientNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'inspections',
    name: 'Scheduled Inspections',
    url: '/dcra-inspections/inspections',
    path: '/dcra-inspections/inspections/:id',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/client/messaging/inbox',
    path: '/client/messaging/:id',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'profile',
    name: 'My Profile',
    url: '/client/profile',
    path: '/client/profile/main',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: clientDcraGuideUrl,
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/client/settings',
    path: '/client/settings/:id',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getElevatorsClientNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'elevatorsProjects',
    name: 'My Projects',
    url: '/elevators/projects',
    path: '/elevators/projects/:id',
    icon: <WindowBookmarkIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsInvitations',
    name: 'Invitations',
    url: '/elevators/invitations',
    path: '/elevators/invitations',
    icon: <InvitationsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsInspections',
    name: 'Inspections',
    url: '/elevators/inspections',
    path: '/elevators/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsCertificates',
    name: 'Certificates',
    url: '/elevators/certificates',
    path: '/elevators/certificates',
    icon: <CertificatesMenuIcon />,
    disabled: false,
    show: true,
  },

  {
    id: 'messaging',
    name: 'Messaging',
    url: '/client/messaging/inbox',
    path: '/client/messaging/:id',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'profile',
    name: 'My Profile',
    url: '/client/profile',
    path: '/client/profile',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: clientDcraGuideUrl,
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/client/settings',
    path: '/client/settings/:id',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getClientsApps = (): Params[] => [
  {
    id: 'third-party',
    name: '3rd Party Inspections',
    homeUrl: '/client/dashboard',
  },
  {
    id: 'dcra-inspections',
    name: 'DOB Inspections',
    homeUrl: '/dcra-inspections/inspections',
  },
  (isLoggedInAsAdmin() && {
    id: 'admin-panel',
    name: 'Back To Admin Panel',
    homeUrl: getAdminLink(),
    isExternal: true,
  }) ||
    {},
  // {
  //   id: 'elevators',
  //   name: 'Elevators',
  //   homeUrl: '/elevators',
  // },
];
